import { render, staticRenderFns } from "./GardenStats.vue?vue&type=template&id=81aa73a6&"
import script from "./GardenStats.vue?vue&type=script&lang=js&"
export * from "./GardenStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports